import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from '../shared/shared.module';
import { ExportDataDispatcher } from './export-data.dispatcher';
import { ExportDataEffects } from './export-data.effects';
import { ExportDataService } from './export-data.service';
import { ExportPermissionGuard } from './export-permission.guard';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EffectsModule.forFeature([ExportDataEffects]),
  ],
})
export class ExportDataModule {
  static forRoot(): ModuleWithProviders<ExportDataModule> {
    return {
      ngModule: ExportDataModule,
      providers: [
        ExportDataService,
        ExportPermissionGuard,
        ExportDataDispatcher,
      ],
    };
  }
}
